<template>
  <div>
    <v-select
      persistent-hint
      class="mSelect"
      v-model="dataPost[fieldName?fieldName.name:dataField.name]"
      :label="dataField.title ? dataField.title : ''"
      :items="dataField.choices ? dataField.choices : []"
      item-text="value"
      item-value="key"
      :multiple="dataField.params.multiple ? dataField.params.multiple : false"
      clearable
      :rules="dataField.params.required?required:[]"
      @change="change"
      :error="alerts[dataField.name] != null"
      :error-messages="alerts[dataField.name]"
    ></v-select>
    
  </div>
</template>

<script>
export default {
  name: "SelectBox",
  props: ["dataField","fieldName"],
  computed: {
    dataPost: {
      get() {
        this.$store.commit("updateDataPost", this.$store.state.dataPost);
        return this.$store.state.dataPost;
      },
    },
    alerts: {
      get() {
        return this.$store.state.alerts;
      },
    },
  },
  methods:{
    change(e){
      let val = this.dataField.choices.filter(item => { return item.key==e })[0].value;
      this.alerts[this.dataField.name]=null
       this.$store.commit("updateReviewFieldByIndex", {
              index: this.dataField.name,
              val: val,
            });
    }
  },
  data: () => ({
    required: [
      (v) => !!v || 'اجباری می باشد',
    ],
  }),
};
</script>
